import axios from "axios"

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/api',
  withCredentials: true,
})

axiosInstance.interceptors.request.use(async req => {
  const token = localStorage.getItem("accessToken")
  if (token) {
    req.headers['Authorization'] = 'Bearer ' + token
  }
  return req;
})

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 403) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("participantName");
      window.location.href = '/login';
      return Promise.reject(error);
    }
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const response = await axios.post(
          process.env.REACT_APP_BASE_URL + '/api/auth/refresh',
          {},
          { withCredentials: true }
        );

        if (response.data.success && response.data.accessToken) {
          localStorage.setItem("accessToken", response.data.accessToken);
          originalRequest.headers['Authorization'] = 'Bearer ' + response.data.accessToken;
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("participantName");
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance